import React, { useCallback, useRef, useEffect } from 'react';
import { Input, Space, Row } from 'antd';
import debounce from 'lodash/debounce';

const { Search } = Input;

const style = {
  container: {
    height: '50px',
    border: '0.5px solid #e8e8e8',
    background: '#FAFAFA',
    padding: '8px 30px',
  },
};

const SearchBar = ({ onSearch, onSearchChange, searchLoading }) => {
  const debouncedSearch = useRef(
    debounce((value) => {
      if (onSearchChange) {
        onSearchChange(value);
      }
    }, 300)
  ).current;

  // Cleanup debounce on unmount to prevent memory leaks
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const handleChange = useCallback(
    (e) => {
      const value = e.target.value;
      debouncedSearch(value);
    },
    [debouncedSearch]
  );

  return (
    <div style={style.container}>
      <Row>
        <Space align="center">
          <Search
            placeholder="Search Org"
            allowClear
            onSearch={onSearch}
            onChange={handleChange}
            loading={searchLoading}
          />
        </Space>
      </Row>
    </div>
  );
};

export default SearchBar;
